/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { getHygraphCosmosPageData, ContentTypeNames } from "@cosmos/hygraph-data";
import {
	EntityTypeName,
	EntityWhereInput,
	Locale,
	RefSectionsEntitiesFragment,
	RefSectionsFragment,
} from "@cosmos/hygraph-schema";

import { getExternalSectionData } from "./external";
import { CosmosSectionQuery } from "./page.types";

export const getSectionEntityContentType = (typename: EntityTypeName): ContentTypeNames => {
	return typename.replace(/^Cosmos/, "CosmosPage") as ContentTypeNames;
};

export const getSectionEntityQueries = (
	entities: EntityWhereInput[],
	locale: string,
	lang: string,
	preview?: string,
): Promise<CosmosSectionQuery>[] => {
	const promises = entities.map((entity) => {
		const contentType = getSectionEntityContentType(entity.typename);
		const promise = getHygraphCosmosPageData(
			contentType,
			{
				entities: [entity],
				locale: [locale, Locale.En] as Locale[],
			},
			preview,
		)
			.then((sectionData) => getExternalSectionData(contentType, lang, sectionData as CosmosSectionQuery))
			.catch((e) => console.error("Section load error", { entity, error: e }));

		return promise;
	});

	return promises;
};

/**
 * Fetch the entitles for the sections
 */
export const getRefSectionEntities = (
	refSectionsEntities: RefSectionsEntitiesFragment[] | undefined | null,
	locale: string,
	lang: string,
	preview?: string,
): Promise<CosmosSectionQuery>[] => {
	if (refSectionsEntities) {
		const entities = refSectionsEntities
			.filter((refSection) => refSection.section?.__typename)
			.map(
				(refSection) =>
					({
						id: refSection.section?.id,
						stage: refSection.section?.stage,
						typename: EntityTypeName[refSection.section!.__typename],
					}) as EntityWhereInput,
			);

		if (entities.length) {
			return getSectionEntityQueries(entities, locale, lang, preview);
		}
	}

	return [];
};

export const getRefSectionDetails = (initResponses: CosmosSectionQuery[]): RefSectionsFragment[] => {
	const filtered = initResponses?.filter((element) => !!element);

	const refSections: RefSectionsFragment[] = (filtered || [])
		.map((res) => res?.entities || [])
		.flat()
		.map((section) => ({
			section: section,
		}));

	return refSections;
};
